<mat-progress-bar color="accent" mode="indeterminate" *ngIf="isLoading" style="position:absolute;"></mat-progress-bar>

<div fxFlex="row" fxFlex style="width: 100%;">
    <div fxFlex="240px" class="sidenavigationTop hidexs">
        <div class="iwg-service-name">MyTalent</div>
        <div class="sidenavigationInner">
            <div>
                <button mat-button class="sidenavigationassbtn active-side-nav" (click)="OnClickMyTalent()" layout>
                    Profile
                    <span class="textSuccess activeiconcolor"></span>
                </button>
            </div>
            <app-buttonbar></app-buttonbar>
        </div>
    </div>

    <div fxFlex="calc(100% - 240px)" fxFlex.xs="100">
        <div class="content">
            <div class="iwg-page-header-breadcrumb">
                <span>MyTalent</span> » <span class="iwg-page-header-small-title">Profile</span>
            </div>
         

            <div class="iwg-widget-box iwg-quote-workers-details-boxNOT" style="width: 100%;">
                <div class="iwg-widget-box-bodyNOT" layout="column" style="padding:0px 20px 0px 20px;">
                    <form name="workerProfile1" #workerProfile1="ngForm" (ngSubmit)="submit()" class="mytalentprofile">
                        <div layout>
                            <div flex style="margin: 7px 0px 0px 0px;font-size: 16px;">
                                MyTalent
                            </div>
                        </div>
                        <div layout>
                            <div class="iwg-widget-box-card" style="padding: 10px 2px;">
                                <label class="iwg-regular-label">{{ WorkerDisplayName }} Name</label>
                                <p class="iwg-regular-value">{{ WorkerName | blank}}</p>
                            </div>
                        </div>
                        <div layout>
                            <div flex  class="myvista-search-matform">
                                <div>
                                    <mat-form-field class="example-full-width">
                                        <mat-label>Profile</mat-label>
                                        <textarea matInput [(ngModel)]="workerProfile.profile" name="profile"
                                            (input)="enableSave()"
                                            class="text-area-profile-update"></textarea>
                                    </mat-form-field>

                                    <mat-icon matTooltip="Please provide detailed descriptions of your experience, expertise, qualifications, and strengths.
                                    Your input will be utilized by the search functionality in MyTalent."
                                            matTooltipPosition="above" class="md-iwgNavbar-themeicon" style="margin-top: 20px;">
                                            help
                                        </mat-icon>
                                </div>
                             
                            </div>
                        </div>
                        <div layout>
                            <div flex  class="myvista-search-matform">
                                <div>
                                    <mat-form-field class="example-full-width">
                                        <mat-label>Skills</mat-label>
                                        <textarea matInput [(ngModel)]="workerProfile.skills" name="skill"
                                            (input)="enableSave()"
                                            class="text-area-profile-update">
                                        </textarea>
                                    </mat-form-field>
                                    <mat-icon matTooltip="Please provide detailed descriptions of your skills.
                                    Your input will be utilized by the search functionality in MyTalent."
                                                matTooltipPosition="above" class="md-iwgNavbar-themeicon" style="margin-top: 20px;">
                                                help
                                    </mat-icon>
                                </div>
                             
                            </div>
                        </div>
                        <div layout>
                            <div flex  class="myvista-search-matform">
                                <div>
                                    <mat-form-field class="wg-full-width vista-login-label">
                                        <mat-label>LinkedIn URL</mat-label>
                                        <input type="text" class="p-input" matInput maxlength="200" name="URL" style="font-size: 16px;"
                                            (input)="enableSave()" [(ngModel)]="workerProfile.referenceURL">
                                    </mat-form-field>
                                    <mat-icon matTooltip="Please provide your LinkedIn URL." matTooltipPosition="above" class="md-iwgNavbar-themeicon mt-15">
                                        help
                                    </mat-icon>
                                    <div *ngIf="workerProfile.referenceURL != null && workerProfile.referenceURL != ''" class="linked-url-style">
                                        <a style="font-size:12px"
                                            href="{{(workerProfile.referenceURL.indexOf('://') === -1) ? 'https://' + workerProfile.referenceURL : workerProfile.referenceURL}}"
                                            href="" target="_blank">View LinkedIn Profile</a>
                                    </div>
                                </div>                                
                            </div>
                        </div>
                        <div fxLayout="row" fxLayoutWrap="wrap" style="margin-top: 1.25em;" [ngStyle.lt-md]="{'justify-content': 'center'}">
                            <app-file-upload [upload-url]="'/Api/WorkerProfile/UploadFile'"
                                [file-property]="'worker_profile_resume'" [uploaded-file-name]="ResumeFileName" [isBlur]="true">
                            </app-file-upload>
                          
                            <button type="button" mat-button *ngIf="ResumeFileID > 0 " (click)="downloadResume()"
                                class="mat-icon-resume-icon-button" [disabled]="isLoading">
                                <mat-icon class="mat-icon-resume-icon">file_download</mat-icon>
                            </button>
                         
                            <button type="button" mat-button *ngIf="ResumeFileID > 0 " (click)="deleteFile()"
                                class="mat-icon-resume-icon-button" [disabled]="isLoading">
                                <mat-icon class="mat-icon-resume-icon">delete</mat-icon>
                            </button>
                        </div>
                        <div layout>
                            <div flex style="text-align:center">
                                
                                <button mat-button type="submit" class="md-primary md-raised iwg-md-raised "
                                    style="background-color: #224d95; color: rgba(255,255,255,0.87);margin: 20px;min-height: 36px;min-width: 88px;"
                                    (click)="preventSubmit(false)" [ngClass]="buttonCss"
                                    [disabled]="isLoading || !hasData">
                                    Submit
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="innerpage-footer">
            <app-iwg-footer [blurBg]="true"></app-iwg-footer>
        </div>
    </div>
</div>